import { createMiddleware } from '@shared/redux';
import { trackOnRudderStack } from '@domain/analytics';
import {
    getStep,
    CHANGE_NEW_CAMPAIGN_MODAL_STEP,
    OPEN_NEW_CAMPAIGN_MODAL,
} from '@domain/partnerships/partners/mobees/new-campaign/interface/interface.state';
import {
    CREATE_CAMPAIGN_REQUEST_CALLED,
    CREATE_CAMPAIGN_REQUEST_SUCCEEDED,
    CREATE_CAMPAIGN_REQUEST_FAILED,
} from '@domain/partnerships/partners/mobees/new-campaign/campaign/campaign.state';
import { PLATFORMS } from '@domain/platform';
import { match } from '@shared/utils/match';
import { LOCATION_CHANGE } from 'connected-react-router';
import { PARTNERSHIPS_ROUTERS } from '@domain/partnerships';

export const mobeesMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [PARTNERSHIPS_ROUTERS.MOBEES]: () => {
            trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: 'visit' });
        },
    }),
    [OPEN_NEW_CAMPAIGN_MODAL]: () => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: 'new_campaign' });
    },
    [CHANGE_NEW_CAMPAIGN_MODAL_STEP]: (state) => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: `step_${getStep(state)}` });
    },
    [CREATE_CAMPAIGN_REQUEST_CALLED]: () => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: 'campaign_called' });
    },
    [CREATE_CAMPAIGN_REQUEST_SUCCEEDED]: () => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: 'campaign_succeeded' });
    },
    [CREATE_CAMPAIGN_REQUEST_FAILED]: () => {
        trackOnRudderStack('partnerships', { platform: PLATFORMS.MOBEES.value, action: 'campaign_failed' });
    },
});
